(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-banner"]) return;
  try {
    
  if (!!document.querySelector(".shopify-section--collection-banner .image-overlay__image-wrapper") === true){
    function menuTransparent() {
      var width_screen = window.innerWidth;
      if (width_screen < 740) {
        var numberScroll = 50;
      } else {
        var numberScroll = 100;
      }
      var top_page = window.scrollY;
      if (top_page > numberScroll) {
        if (document.querySelector("store-header.header").classList.contains("header--transparent") === true) {
          document.querySelector("store-header.header").classList.remove("header--transparent");
        }
        if (document.querySelector("#mobile-facet-toolbar").classList.contains("transparent") === true) {
          document.querySelector("#mobile-facet-toolbar").classList.remove("transparent");
        }
      } else {
        if (document.querySelector("store-header.header").classList.contains("header--transparent") === false) {
          document.querySelector("store-header.header").classList.add("header--transparent");
        }
        if (document.querySelector("#mobile-facet-toolbar").classList.contains("transparent") === false) {
          document.querySelector("#mobile-facet-toolbar").classList.add("transparent");
        }
    
        // Ajout des événements hover dans la condition else
        const storeHeader = document.querySelector("store-header.header");
        
        // Ajouter l'événement mouseenter (hover)
        storeHeader.addEventListener("mouseenter", function() {
          if (storeHeader.classList.contains("header--transparent")) {
            storeHeader.classList.remove("header--transparent");
          }
        });
        
        // Ajouter l'événement mouseleave (fin du hover)
        storeHeader.addEventListener("mouseleave", function() {
          if (!storeHeader.classList.contains("header--transparent")) {
            storeHeader.classList.add("header--transparent");
          }
        });
      }
    }
    menuTransparent();
    
    window.addEventListener('scroll',(event) => {
      menuTransparent();
    });

    document.head.insertAdjacentHTML('beforeend', '<style>.shopify-section--header, .shopify-section--announcement-bar{position: fixed !important;width: 100vw !important;}</style>');
  }else{
    document.head.insertAdjacentHTML('beforeend', '<style>.shopify-section.shopify-section--collection-banner{margin-top: 110px !important;}@media only screen and (min-width: 1200px) {.shopify-section.shopify-section--collection-banner{margin-top: 170px !important;}}@media only screen and (max-width: 740px) {.shopify-section.shopify-section--collection-banner{margin-top: 80px !important;}}</style>');
  }

  } catch(e) { console.error(e); }
})();
})();
